module.exports = __webpack_public_path__ + "media/fonts/superstudio-regular-30b7e9d7e6158ffecd047912038415fa.woff2";